import { motion } from "framer-motion";
import ChapterMarker from "../ChapterMarker";
import { EDUCATION, SECTIONS } from "../../data/content";

export default function Education() {
  const s = SECTIONS[5];
  return (
    <section
      id={s.id}
      style={{ minHeight: `${s.weight * 100}vh` }}
      className="relative flex items-center justify-end px-6 md:px-12 lg:px-24 py-24"
      data-testid="section-education"
    >
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-15%" }}
        transition={{ duration: 0.6 }}
        className="pointer-events-auto max-w-md border border-[#01FFFF]/20 bg-[#0A0A12]/60 backdrop-blur-xl p-8"
      >
        <ChapterMarker number={s.number} label={s.label} />
        <div className="space-y-6">
          {EDUCATION.map((ed) => (
            <div key={ed.id} data-testid={`education-item-${ed.id}`}>
              <h4 className="font-heading text-base md:text-lg uppercase text-[#E0E6ED]">
                {ed.institution}
              </h4>
              <p className="font-mono text-xs text-[#01FFFF] mt-1">{ed.degree}</p>
              <p className="font-mono text-[11px] text-[#8A9AAB] mt-1">
                {ed.detail} {ed.period && `· ${ed.period}`}
              </p>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
